import { orderStatuses } from '../../../utilities/helpers'

export const listingFor = (order) => order?.details?.listing

export const listingIdFor = (order) => {
  const id = Number(listingFor(order)?.id)
  return Number.isFinite(id) && id > 0 ? id : null
}

export const ticketType = (order) => {
  const listing = listingFor(order)
  return (
    listing?.packageName ||
    listing?.tickets?.[0]?.name ||
    listing?.offer?.name ||
    ''
  )
}

export const listingQuantity = (order) => {
  const listing = listingFor(order)
  const quantity = listing?.quantity ?? order?.details?.ticketCount
  return Number(quantity) || 0
}

export const orderStatus = (order) => {
  if (!order?.status) return null
  return (
    orderStatuses[order.status] || {
      label: order.status,
      value: order.status,
    }
  )
}

export const buyerName = (order) =>
  [order?.firstName, order?.lastName].filter(Boolean).join(' ').trim()
